var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-jm",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 320 240L0 480zm640 0L320 240l320 240z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#090",
    d: "m0 0 320 240L640 0zm0 480 320-240 320 240z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M640 0h-59.6L0 435.3V480h59.6L640 44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M0 0v44.7L580.4 480H640v-44.7L59.6 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJm);
export default __webpack_public_path__ + "static/media/jm.bbf9bcce8cefb8d15d88deeb7dfec194.svg";
export { ForwardRef as ReactComponent };